<template>
	<div class="header">
	         <div class="main-header">
	         	    <div class="logo-img">
	        	    		<img src="../../assets/img/logo.png" width=177 height=32 @click="goPage('/')">
	        	    </div>
	        	    <ul class="box-list-left">
	        	    	   <li :class="problemClass" @click="goPage('/')">문제풀기</li>
	        	    	   <li :class="advisorClass" @click="goPage('/advisor/list')">어드바이저</li>
	        	    	   <li :class="reportClass"  @click="goPage('/problem/myreport')">성적확인</li>
	        	    </ul>
	        	    <ul class="box-list-right" v-if="login">
	        	    	   <li @click="logOut">로그아웃</li>
	        	    	   <li class="active"  @click="goPage('/member/memberInfo')">마이페이지</li>
	        	    </ul>
					<ul class="box-list-right" v-else>
	        	    	   <li @click="goPage('/member/login')">로그인</li>
	        	    	   <li class="active"  @click="goPage('/member/join')">회원가입</li>
	        	    </ul>
					
					<div style='clear:both;'></div>
	         </div>
			 <div class="header-main-2" v-if="subMenuView">
			        <div class="box-list-header" :style="{'width':subMenuWidth,'margin':'0 auto'}">
			             <ul v-for="item in subMenuList" @click="goSubPage(item)" :class="item.gclass">
					          <li>{{item.name}}</li>
					     	  <li></li>
					     </ul>
					</div>
		      </div>
			 <Intro v-if="introView"></Intro>		 
	   </div>

</template>

<script>
import Intro from '@/components/inc/Intro'

export default {
  name: 'HeaderLayout',
  components: {
	  Intro,
  },
  props:["pagecode","subpagecode"],
  watch: {
	subpagecode(val) {
		if(this.pagecode =='pview') {
			this.subMenuList = [];
			this.makeMenu(val)
		}
	}
		
  },
  data () {
	return {
		userInfo:{},
		introView:false,
		login:false,
		subMenuView:false,
		subMenuList:[],
		subMenuWidth:'800px',
		problemClass:'',
		advisorClass:'',
		reportClass:'',
	}
  },
  created: function() {
	  //localStorage.setItem('intro','');
	   //sessionStorage.setItem('memberkey','');
	   this.userInfo = sessionStorage.getObject('memberInfo')
	   var intro = localStorage.getItem('intro')
	   if(intro!='used') {
			this.introView = true;
	   } else {
		   if(this.pagecode!='join') {
				if(!sessionStorage.getItem('memberkey')) {
	 				this.$router.push({ path:'/member/login'})	
					return;
				} else {
					this.login = true;
				}
		   }
	   }
	   this.makeMenu(this.subpagecode);
  },
  methods: {
	   makeMenu(subpagecode) {
		   switch(this.pagecode) {
				case 'main':
					var item = {code:'ai',name:'A.I문제풀기',gclass:'main-ul active'};
					this.subMenuList.push(item);
					var item = {code:'me',name:'내가풀기',gclass:'main-ul'};
					this.subMenuList.push(item);
					this.subMenuView=true;
					this.subMenuWidth = '400px';
					this.problemClass = 'active';
				break;
				case 'pview':
					var item = {code:'ai',name:'A.I문제풀기',gclass:''};
					this.subMenuList.push(item);
					var item = {code:'aireport',name:'A.I성적표',gclass:''};
					this.subMenuList.push(item);
					var item = {code:'me',name:'내가풀기',gclass:''};
					this.subMenuList.push(item);
					var item = {code:'mereport',name:'내성적표',gclass:''};
					this.subMenuList.push(item);
					for(var k in this.subMenuList) {
						var data = this.subMenuList[k];
						if(subpagecode == data.code) {
							data.gclass='active';	
							this.$set(this.subMenuList,k,data);
							break;
						}
					}
					this.subMenuView=true;
					this.subMenuWidth = '800px';
					this.problemClass = 'active';
				break;
				case 'myreport':
					var item = {code:'ai',name:'A.I아바타의 성적표',gclass:'main-ul active'};
					this.subMenuList.push(item);
					var item = {code:'me',name:'내 성적표',gclass:'main-ul'};
					this.subMenuList.push(item);
					this.subMenuView=true;
					this.subMenuWidth = '400px';
					this.reportClass = 'active';
				break;
				case 'advisor':
					var active1 = (this.subpagecode == 'list')?' active':'';
					var active2 = (this.subpagecode == 'sentence')?' active':'';
					var active3 = (this.subpagecode == 'word')?' active':'';
					var active4 = (this.subpagecode == 'problem')?' active':'';
					
					var item = {code:'list',name:'추천 영상보기',gclass:'main-ul '+active1};
					this.subMenuList.push(item);
					var item = {code:'problem',name:'추천 문제보기',gclass:'main-ul '+active4};
					this.subMenuList.push(item);
					var item = {code:'sentence',name:'추천 독해보기',gclass:'main-ul '+active2};
					this.subMenuList.push(item);
					var item = {code:'word',name:'추천 어휘보기',gclass:'main-ul '+active3};
					this.subMenuList.push(item);
					
					
					this.subMenuView=true;
					this.subMenuWidth = '800px';
					this.advisorClass = 'active';
				break;
				case 'mypage':
					var active1 = (this.subpagecode != 'ai')?' active':'';
					var active2 = (this.subpagecode == 'ai')?' active':'';
					var item = {code:'upd',name:'회원정보 수정',gclass:'main-ul'+active1};
					this.subMenuList.push(item);
					var item = {code:'aiupd',name:'A.I아바타 재설정',gclass:'main-ul'+active2};
					this.subMenuList.push(item);
					this.subMenuView=true;
					this.subMenuWidth = '400px';
				break;
		   }
	  },
	  logOut() {
		  sessionStorage.setItem('memberkey','');
		  sessionStorage.setObject('memberInfo','');
		  this.goPage('/member/login');
	  },
	  goPage(url) {
		 
		this.$router.push({ path:url})
		
	  },
	   goSubPage(item) {
		   if(item.code) {
				for(var k in this.subMenuList) {
					var data = this.subMenuList[k];
					data.gclass = (data.code == item.code)?'main-ul active':'main-ul';
					this.$set(this.subMenuList,k,data);
				}
				this.$emit('eventProblemCode',item.code);
		   
		   }
	  },
	  goMypage() {
		if(this.login) {
			this.$router.push({ path:'/member/mypage'})
		} else {
			this.$router.push({ path:'/member/login'})	
		}
	  },
	  
  },
  mounted: function() {
	
  },
  updated() {
  }

}
</script>

<style lang="scss" scoped>

.header				{
	background:#fff;
	width:100%;
	-webkit-box-shadow: 0px 1px 8px -1px rgba(0,0,0,0.71);
    -moz-box-shadow: 0px 1px 8px -1px rgba(0,0,0,0.71);
    box-shadow: 0px 1px 8px -1px rgba(0,0,0,0.71);
	z-index:1000;
	font-family: 'Nanum Gothic', sans-serif;
	line-height:72px;
	position:fixed;
	top:0;
	left:0;
	.main-header       {
				width:100%;
				height:75px;
				line-height:75px;
			    padding:0 20px;			                 
				.logo-img              {
	           			width:177px;
	           			height:31px;
	           			text-align:center;
	           			float:left;
						cursor:pointer;
	           }
	           .box-list-left         {
	           			display:flex;
	           			float:left;
	           			margin-left:100px;
	           			li			        {
	           					   margin-left:48px;
	           					   font-size:13pt;
	           					   color:#333333;
								   font-weight:bold;
								   cursor:pointer;
	           			}
						li.active {
							color:#407AFF;
						}
	           }
	           .box-list-right        {
	           			display:flex;
	           			float:right;
	           			li               {
	           					   margin-left:28px;
	           					   font-size:12pt;
	           					   color:#333333;
								   font-weight:bold;
								   cursor:pointer;
	           			}
	           			li.active         {
	           						width:100px;
	           						height:40px;
	           						color:#fff;
	           						line-height:40px;
	           						text-align:center;
	           						background:#999999;
	           						position:relative;
	           						top:16px;
	           			}
	           }
	}
	.header-main-2  {
			 width:100%;
			 height:59px;
			 line-height:55px;
			 border-top:1px solid #F4F4F4;
			 .box-list-header           {
			 				  display:flex;
							  ul              {
							  		   width:25%;
									   text-align:center;
									   li                  {
									   			font-weight:bold;
												font-size:13px;
												color:#C9C9C9;
												cursor:pointer;
									   }
									  
							   }
							   ul.main-ul {
									width:50%;
							   }
							   ul.active         {
							            li:first-child           {
										       color:#737F9C;
										}
										li:last-child           {
										       width:100%;
											   height:3px;
											   background:#737F9C;
										}
							   }
			}
	}

}
</style>